import React from 'react';
import LegalLayout, { Section } from '../components/LegalLayout';

const PrivacyPolicy = () => (
  <LegalLayout title="Privacy Policy" effectiveDate="August 28, 2026">
    <Section title="">
      <p>
        YOVAI LLC ("YOVAI," "We," "Our," Or "Us") Respects The Privacy Of Our Clients, Website Visitors, And Individuals Who Interact With Services Powered By YOVAI.
      </p>
    </Section>

    <Section title="1. Information We May Collect">
      <p>YOVAI May Process Information Including:</p>
      <ul>
        <li>Names</li>
        <li>Business Names</li>
        <li>Email Addresses</li>
        <li>Telephone Numbers</li>
        <li>Billing And Transaction Information</li>
        <li>Appointment And Scheduling Information</li>
        <li>Communications</li>
        <li>Call-Related Information</li>
        <li>Messages</li>
        <li>Website Usage Information</li>
        <li>Device And Browser Information</li>
        <li>Technical And Diagnostic Information</li>
      </ul>
    </Section>

    <Section title="2. How Information May Be Used">
      <p>YOVAI May Use Information To:</p>
      <ul>
        <li>Provide And Operate Services</li>
        <li>Configure AI Receptionists</li>
        <li>Handle Business Communications</li>
        <li>Facilitate Scheduling</li>
        <li>Provide Lead Capture And Follow-Up</li>
        <li>Provide Customer Support</li>
        <li>Process Payments</li>
        <li>Maintain Security</li>
        <li>Troubleshoot Issues</li>
        <li>Improve Services</li>
        <li>Maintain Business Records</li>
        <li>Comply With Applicable Legal Obligations</li>
      </ul>
    </Section>

    <Section title="3. AI-Powered Interactions">
      <p>Certain YOVAI Services Use Artificial Intelligence And Automated Technologies.</p>
      <p>Individuals May Communicate With An AI-Powered Or Automated Agent Rather Than A Human Representative.</p>
    </Section>

    <Section title="4. Service Providers">
      <p>
        YOVAI May Use Third-Party Providers For Telecommunications, Messaging, Artificial Intelligence, Hosting, Scheduling, Payment Processing, Analytics, Integrations, And Related Services.
      </p>
    </Section>

    <Section title="5. Payment Information">
      <p>Payments May Be Processed By Third-Party Payment Processors.</p>
      <p>
        YOVAI Generally Does Not Directly Store Complete Payment Card Information When Payment Information Is Processed By A Third-Party Provider.
      </p>
    </Section>

    <Section title="6. Data Security">
      <p>YOVAI Uses Reasonable Administrative, Technical, And Organizational Measures Intended To Protect Information.</p>
      <p>No Internet-Based Or Electronic System Can Be Guaranteed To Be Completely Secure.</p>
    </Section>

    <Section title="7. Data Retention">
      <p>
        Information May Be Retained As Reasonably Necessary To Provide Services, Maintain Business Records, Resolve Disputes, Enforce Agreements, Maintain Security, And Comply With Legal Obligations.
      </p>
    </Section>

    <Section title="8. Client Responsibilities">
      <p>
        Businesses Using YOVAI Are Responsible For Ensuring Their Use Of The Services Complies With Applicable Privacy, Communications, Recording, Consent, And Industry-Specific Laws.
      </p>
    </Section>

    <Section title="9. Privacy Rights">
      <p>Depending On Applicable Law, Individuals May Have Rights Concerning Their Personal Information.</p>
    </Section>
  </LegalLayout>
);

export default PrivacyPolicy;
